import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

import { Pricing } from '../pricing/pricing';
import { Salesperson } from './salesperson';

@Component({
  selector: 'store-salesperson-details',
  templateUrl: './salesperson-details.component.html',
  styleUrls: ['./salesperson-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VaSalespersonDetailsComponent {
  @Input() salesperson: Salesperson;
  @Input() packagePricing: Pricing;
  @Input() brandName: string;
  @Input() showGetItNow = true;
  @Input() actionLabel = 'Buy';
  @Output() getItNow = new EventEmitter();

  onGetItNowSelected(): void {
    this.getItNow.emit(this.salesperson);
  }

  get iconUrl(): string {
    return this.salesperson && this.salesperson.photoUrlSecure
      ? this.salesperson.photoUrlSecure
      : 'https://vbc-frontend.storage-download.googleapis.com/salesperson-details/default_sales_person.jpg';
  }

  get name(): string {
    return this.salesperson && this.salesperson.formattedName ? this.salesperson.formattedName : '';
  }

  get title(): string {
    return this.salesperson && this.salesperson.jobTitle ? this.salesperson.jobTitle : '';
  }

  get email(): string {
    return this.salesperson && this.salesperson.email ? this.salesperson.email : '';
  }

  get cityAndState(): string {
    return this.salesperson && this.salesperson.city && this.salesperson.state
      ? this.salesperson.city + ', ' + this.salesperson.state
      : '';
  }
}
